module.exports = require('./convert')(
  "=!\"#$%&'()*+-/0123456789:;<>?@[\\]^_`yz{|}~",
  "´1!3457§908ˇ=-é+ěščřžýáí\"ů?:_2ú¨)6%;zy/'(°"
)
